const { get } = require('@ebay/str-ui-utils/retriever');
const { dispatchTracking } = require('@ebay/str-ui-utils/tracking-util');
const config = require('../../../config.json');

module.exports = {
    onCreate() {
        this.state = {
            copiedToClipboard: false,
            ariaLive: 'polite'
        };
        this.timeout = config['copy-url'].timeoutCopyUrl;
    },

    onInput(input) {
        this.copyUrl = get(input, 'shareUrlAction.URL', '');
    },

    startTimer() {
        this.timer = setTimeout(() => {
            // reset to default state icon on timeout
            this.resetCopyState();
        }, this.timeout);
    },

    resetCopyState() {
        this.state.copiedToClipboard = false;
        // set aria-live off for forever
        // as per a11y review meeting, the change should be conveyed once
        this.state.ariaLive = 'off';
    },

    handleClick(event) {
        /* If the timer is going on (state is copied)
        don't do anything. timer should not be interrupted. Clipboard should not be changed.
        If the timer is expired or not started (state in not copied),
        transit to state copied and start the timer and copy url to clipboard
        */
        if (!this.state.copiedToClipboard) {
            dispatchTracking(event);
            this.copyToClipBoard();
            this.startTimer();
        }
    },

    copyToClipBoard() {
        navigator.clipboard.writeText(this.copyUrl);
        this.state.copiedToClipboard = true;
    },

    onDestroy() {
        clearTimeout(this.timer);
    }
};
